import { useEffect, useRef, useState } from 'react';
import ReactImageMagnify from 'react-image-magnify';
import { InfoIcon } from '@phosphor-icons/react';
import Tooltip from '../tooltip';
import './styles.scss';


const GalleryImage = ({ src, index, onLoad, onError, description }) => {
    const [isZoomed, setIsZoomed] = useState(false);
    const smallImageRef = useRef(null);

    useEffect(() => {
        if (isZoomed && smallImageRef.current) {
            const rect = smallImageRef.current.getBoundingClientRect();
            const evt = new MouseEvent('mousemove', {
                clientX: rect.left + rect.width / 2,
                clientY: rect.top + rect.height / 2,
                bubbles: true
            });
            smallImageRef.current.dispatchEvent(evt);
        }
    }, [isZoomed]);

    return (
        <div
            className='image-container'
            onClick={() => setIsZoomed(z => !z)}
            style={{ cursor: isZoomed ? 'zoom-out' : 'zoom-in' }}
        >
            {isZoomed ? (
                <ReactImageMagnify
                    {...{
                        smallImage: {
                            isFluidWidth: true,
                            src,
                            ref: smallImageRef
                        },
                        largeImage: { src, width: 2000, height: 2000 },
                        imageClassName: "image-magnify",
                        className: "image-magnify-container",
                        enlargedImageContainerClassName: "image-zoomed-container",
                        enlargedImagePosition: 'over',
                        lensStyle: { backgroundColor: 'rgba(0,0,0,0.6)' }
                    }}
                />
            ) : (
                <img
                    src={src}
                    alt=""
                    onLoad={() => {
                        console.log('GalleryImage onLoad called for index:', index);
                        onLoad && onLoad(index);
                    }}
                    onError={() => {
                        console.log('GalleryImage onError called for index:', index);
                        onError && onError(index);
                    }}
                />
            )}
            {description && (
                <div className='image-description' onClick={(e) => e.stopPropagation()}>
                    <Tooltip text={description} position='left'>
                        <InfoIcon size={28} />
                    </Tooltip>
                </div>
            )}
        </div>
    );
}

export default GalleryImage;
